
import { Component, Vue } from 'vue-property-decorator';
import { ValidationObserver } from 'vee-validate';

import { sharedState } from '../../../state';
import { UserInfo } from '../../../../../common/framework/model/UserInfo';
import { postUser } from '../../../client/users';
import { postRequestTokenPasswordChange } from '../../../client/password';
import UserGroups from './UserGroups.vue';
import TextField from '../../../fields/TextField.vue';
import PhoneField from '../../../fields/PhoneField.vue';
import SelectField from '../../../fields/SelectField.vue';
import EmailField from '../../../fields/EmailField.vue';
import SwitchField from '../../../fields/SwitchField.vue';
import UserRoles from './UserRoles.vue';

@Component({
    components: {
        SwitchField,
        SelectField,
        PhoneField,
        TextField,
        EmailField,
        UserRoles,
        UserGroups,
        ValidationObserver,
    },
})
export default class AddUser extends Vue {
    shared = sharedState;
    local = {
        localeOptions: [
            { id: 'fi', label: 'FI' },
            { id: 'en', label: 'EN' },
        ],
        firstName: '',
        lastName: '',
        email: '',
        phone: '',
        locale: '',
        locked: false,
    };
    id = '';

    $refs!: {
        userRoles: UserRoles;
        userGroups: UserGroups;
    };

    async mounted() {}

    async add() {
        const addedUser = await postUser(
            new UserInfo(
                this.local.firstName,
                this.local.lastName,
                this.local.email,
                this.local.phone,
                this.local.locale,
                false,
            ),
        );
        this.id = addedUser.id;
        await (this.$refs.userRoles as any).saveWithUserId(addedUser.id);
        await (this.$refs.userGroups as any).saveWithUserId(addedUser.id);

        this.$router.push('/users');
        if (await postRequestTokenPasswordChange(this.local.email)) {
            this.$buefy.toast.open({
                message: 'User added and invited.',
                type: 'is-success',
                position: 'is-top',
            });
        } else {
            this.$buefy.toast.open({
                message: 'User added but invitation failed.',
                type: 'is-warning',
                position: 'is-top',
            });
        }

        this.local.firstName = '';
        this.local.lastName = '';
        this.local.email = '';
    }

    back() {
        this.$router.go(-1);
    }
}
